import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=155d5a7c&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=js&"
export * from "./UserTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=155d5a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d5a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155d5a7c')) {
      api.createRecord('155d5a7c', component.options)
    } else {
      api.reload('155d5a7c', component.options)
    }
    module.hot.accept("./UserTable.vue?vue&type=template&id=155d5a7c&scoped=true&", function () {
      api.rerender('155d5a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/UserTable.vue"
export default component.exports